import { render, staticRenderFns } from "./tagAdd.vue?vue&type=template&id=6b2d51cd&scoped=true&"
import script from "./tagAdd.vue?vue&type=script&lang=js&"
export * from "./tagAdd.vue?vue&type=script&lang=js&"
import style0 from "./tagAdd.vue?vue&type=style&index=0&id=6b2d51cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2d51cd",
  null
  
)

export default component.exports